export const employmentSectorsData = [
    {
        name: 'Commercio e Servizi',
        value: 52,
        region: 'Lazio, Lombardia',
        fill: '#34c759',
    },
    {
        name: 'Industria e Cantieristica',
        value: 28,
        region: 'Friuli, Veneto',
        fill: '#007aff',
    },
    {
        name: 'Agricoltura',
        value: 10,
        region: 'Lazio, Puglia, Sicilia',
        fill: '#ff9500',
    },
    {
        name: 'Ristorazione e Altro',
        value: 10,
        region: 'Nazionale',
        fill: '#af52de',
    },
];
